import 'edge/quoteandbind/common/models/Submission';
import PASubmissionDataExtension from 'edge/quoteandbind/pa/models/PASubmissionDataExtension';
import BOPSubmissionDataExtender from 'edge/quoteandbind/bop/models/BOPSubmissionDataExtender';

export default {
    mixinLobDataExtensions: function mixinLobDataExtensions(submission) {
        if (submission && submission.baseData && submission.baseData.productCode === 'PersonalAuto') {
            submission.lobData = submission.lobData || {};
            submission.lobData.personalAuto = new PASubmissionDataExtension(submission);
        }
        if (submission && submission.baseData && submission.baseData.productCode === 'BusinessOwners') {
            BOPSubmissionDataExtender.extend(submission);
        }
    }
};


//////////////////
// WEBPACK FOOTER
// ./common/js/src/integration/quoteandbind/PolicyLineExtensionConfiguration.js
// module id = 1213
// module chunks = 0